import React, {memo, useCallback, useEffect, useRef, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { useHistory } from 'react-router';
import moment from 'moment';
import _isEqual from 'lodash/isEqual';

import TableLayout from './TableLayout/TableLayout';
import Loader from './Loader/Loader';
import {
  changeClientContract,
  changeContractStatuses,
  clearContractID,
  clearPartialQuenchingData,
  getClientContract,
  getPrintedForm,
  clearClientContract,
  getDealToRetention,
  getDealToRetentionFailed,
  getPartialQuenchingData,
  cancelContract, clearContractError, getOperations, getPrintedFormAutoLombard,
} from '../../../redux/actions/contractAction';
import {resetCalculations, saveCalculations} from '../../../redux/actions/quickCalculationAction';
import {ActionButton, AlertModal, ConfirmModal, IconStatus} from '../../common';
import {CloseDealModal, Message, ProlongModal} from '../../utilites';
import ClientDropdown from '../../../components/utilites/CustomDropdown/DropdownClient/ClientDropdown';
import {
  WITHDRAWAL_OPERATION,
  contractStatuses, dealTypes,
  extendBeforeDate,
  extensionLimitDays,
  creditDealTypeCode,
  listRoles,
  prolongDate,
  viewDocument,
  viewReports,
  optionsPaymentAnnuityDate,
} from '../../../helpers/data-constants';
import LayoutOperations from './LayoutOperations/LayoutOperations';
import ContractTransactions from './Transactions/ContractTransactions';
import EditDealModal from './EditDealModal/EditDealModal';
import {
  CLIENTCONTRACT_OPERATIONS_TAB,
  QUICK_CALCULATION_DATA,
} from '../../../constants/localStorageConstants';
import BuyThirdPersonModal from '../../utilites/modal/CloseModalLayout/BuyThirdPersonModal/BuyThirdPersonModal';
import useStandardProlongDeal from "../../utilites/modal/ProlongModal/hooks/useStandardProlongDeal";
import BasicAlert from '../../utilites/Alert/Alert';
import {calculationAccess, checkForPurity, containsProlongLimitDaysDeal, getCodeFromDeals, permissionsAccess,} from '../../../helpers/common';
import {authService} from '../../../services/auth-service';

import './clientContract.scss';

import CalendarIcon from '../../../assets/icons/calendar.svg';
import KBMessages from './KBMessages/KBMessages';
import { createMessage } from '../../../redux/actions/kbExchangeActions';
import {getCashbox} from '../../../redux/actions/handbookAction';
import PartialQuenchingModal from "./PartialQuenchingModal/PartialQuenchingModal";
import Select from "react-select";
import {errorAccessToContractCreation} from "../../../redux/actions/clientShortInfoAction";
import useClientValidation from '../useClientValidation.hook';
import PayAnnuityPeriod from "../../utilites/modal/PayAnnuityPeriodModal/PayAnnuityPeriod";
import CloseAnnuityDeal from "../../utilites/modal/CloseAnnuityDeal/CloseAnnuityDeal";

const viewDropdown = {
  dealNumber: 'dealNumber',
  basePercent: 'basePercent',
  delayPercent: 'delayPercent',
  cashBox: 'cashBox',
  redemptionDate: 'redemptionDate',
};

const ClientContract = memo( () => {
  const { clientContract, contractError, isLoading, changeContract, contractID, fileError, partialQuenchingData, operations } = useSelector(
    ({ contract }) => contract,
  );

  const { accessFeatures } = useSelector(({ user }) => user);
  const { client } = useSelector(({ clientInfo }) => clientInfo);
  const [state, setState] = useState({
    isProlong: false,
    isEdit: false,
    isPartialQuenching: false,
    isClosed: false,
    isCopy: false,
    isAnnul: false,
    isToTransfer: false,
    isPayAnnuity: false,
    isCloseAnnuityDeal: false,
    isShow: {
      dealNumber: false,
      delayPercent: false,
      cashBoxId: false,
      basePercent: false,
      redemptionDate: false,
    },
    isBuyThirdPerson: {
      isOpen: false,
      data: null,
    },
  });
  const [tabIndex, setTabIndex] = useState(
    +localStorage.getItem(CLIENTCONTRACT_OPERATIONS_TAB) || 0,
  );
  const [alertMessage, setAlertMessage] = useState(null);
  const [popup, setPopup] = useState({isOpen: false, type: 'error', header: 'Ошибка', text: 'Ошибка'});
  const dispatch = useDispatch();
  const history = useHistory();
  const contractId = history.location.pathname.split('/')[4];
  const clientId = history.location.pathname.split('/')[2];
  const notEmpty =
    clientContract && clientContract.positions && clientContract.positions.length !== 0;
  const type = notEmpty && checkForPurity(clientContract);
  const activeCashBoxId = authService.getActiveCashBoxId().value;
  const isShowButton =
    clientContract.status === contractStatuses.ACTIVE.param ||
    clientContract.status === contractStatuses.EXPIRED.param;
  const showCopyButtonByStatus =
    clientContract?.status === contractStatuses.CLOSED.param
  || clientContract?.status === contractStatuses.CANCELED.param
  || clientContract?.status === contractStatuses.UNNECESSARY.param
  || clientContract?.status === contractStatuses.GOHRAN.param
  || clientContract?.status === contractStatuses.SALED_GOHRAN.param
  || clientContract?.status === contractStatuses.SALED_STORE.param
  || clientContract?.status !== contractStatuses.TOTRANSFER.param
  const dataRef = useRef();
  const dataActiveCashbox = authService.getActiveCashBoxId();
  let accessKB = permissionsAccess('action.integration.kb.list');
  const inactiveClient = !client.document || client?.document?.active === false

  const showButtonForMainRoles =  permissionsAccess("action.deal.create");
  const accessPartialQuenchingModal = activeCashBoxId === clientContract.cashBoxId && showButtonForMainRoles;

  const goodSpecialistRole = calculationAccess([listRoles.GOODS_SPECIALIST])
  const adminRole = calculationAccess([listRoles.ADMIN])

  const mainAccessPartialQuenchingModal = clientContract.cashBoxId && adminRole;

  const isValidStatus =
    clientContract.status === contractStatuses.ACTIVE.param ||
    clientContract.status === contractStatuses.EXPIRED.param ||
    clientContract.status === contractStatuses.RETENTION.param;
  const typeAnnuity = clientContract.form === dealTypes.ANNUITY_CLASSIC.dealForm ||
      clientContract.form === dealTypes.ANNUITY_HYBRID.dealForm ||
      clientContract.form === dealTypes.ANNUITY_DELAYED_START.dealForm

  const isActiveStatus = clientContract.status === contractStatuses.ACTIVE.param
      || clientContract.status === contractStatuses.EXPIRED.param;
  const { validateClientId, validateClientStatus, clientIdNumber } = useClientValidation({client});

  const isExtendWithDaysLimit = accessFeatures["deal.extension.days.limit"];  
  const isExtensionThreeImplementaition = accessFeatures["extension.implementation.type.three"] 
  const { validateProlongDeal, isExtendBeforeDate } = useStandardProlongDeal({isExtendWithDaysLimit, isExtensionThreeImplementaition });
  const isDisabledProlong = clientIdNumber || validateProlongDeal({clientContract, view: viewDocument.isProlong})
  const canExtendDeal = permissionsAccess("action.deal.extension") && !isExtendBeforeDate(clientContract?.startDate)
  const newProlongDate = isExtensionThreeImplementaition ? prolongDate.crediton.NEW_PROLONG_DATE : prolongDate.visem.NEW_PROLONG_DATE
  const isNewGlobalProlong = moment(clientContract?.startDate).isAfter(newProlongDate)

  const moneyOperation = [
    {value: '1', label: 'Выдать деньги'},
    {value: '2', label: 'Принять деньги'}]

  const openPrintendForm = useCallback(() => {
    const filename =
      'exp_' +
      clientContract.dealNumber +
      '_' +
      clientContract.startDate +
      '_' +
      clientContract.endDate +
      '.pdf';
    if (clientContract.createdOnline) {
      dispatch(
          getPrintedFormAutoLombard(
              clientContract.dealId,
              filename,
          ),
      );
    } else {
      dispatch(
          getPrintedForm(
              {
                dealId: clientContract.dealId,
                dealType: clientContract.type,
                cashBoxId: dataActiveCashbox.value,
              },
              filename,
              viewReports.PRINTED_DEAL,
          ),
      );
    }

    if (clientContract.type === 'CARS' && !clientContract.createdOnline) {
      dispatch(
        getPrintedForm(
          {
            dealId: clientContract.dealId,
          },
          filename,
          viewReports.CAR_INSPECTION,
        ),
      )
    }
  }, [clientContract, dispatch, dataActiveCashbox.value]);

  useEffect(() => {
    return () =>  {
      dispatch(errorAccessToContractCreation(''))
    }
  }, [dispatch]);


  useEffect(() => {
    const empty = !_isEqual(clientContract, {});
    if (empty) {
      dataRef.current = {
        paramReq: [
          {
            id: clientContract.dealId,
            endDate: clientContract.endDate,
            startDate: clientContract.startDate,
            lastPaidDate: clientContract.lastPaidDate,
            sum: '',
            cashBoxId: clientContract.cashBoxId,
          },
        ],
        clientId: clientContract.clientId,
      };
    }

    if (contractID && empty) {
      openPrintendForm();
      dispatch(clearContractID());
    }
  }, [contractID, dispatch, clientContract, openPrintendForm]);

  useEffect(() => {
    dispatch(getClientContract(contractId));
  }, [dispatch, contractId, changeContract]);

  useEffect(() => {
    if (Object.keys(partialQuenchingData).length !== 0) {
      setState((prev) => ({
        ...prev,
        isPartialQuenching: true,
      }))
    }
  }, [partialQuenchingData]);


  useEffect(() => {
    return () => {
      localStorage.setItem(CLIENTCONTRACT_OPERATIONS_TAB, 0);
      dispatch(clearContractError())

      dispatch(clearPartialQuenchingData());
      dispatch(clearClientContract());
    };
  }, [dispatch]);

  const openModal = useCallback((view) => {
    const viewCloseProlongParam = view === viewDocument.isClosed || view === viewDocument.isProlong;

    if(validateProlongDeal({clientContract, view})) {
      setAlertMessage(extendBeforeDate)
      return
    }
    
    if (validateClientId(viewCloseProlongParam)) return
    const isProlongFeatureActive  = (!isNewGlobalProlong && isExtensionThreeImplementaition) || isNewGlobalProlong;
    if (view === viewDocument.isProlong && isProlongFeatureActive) {
      if (containsProlongLimitDaysDeal({clientContract, isNewGlobalProlong, isExtensionThreeImplementaition})) {
          setPopup((prev) => ({
              ...prev,
              isOpen: true,
              text: extensionLimitDays,
          }));
          return;
      }
  }
    if(view === viewDocument.isKBWithdrawal) {
      dispatch(getOperations(contractId));
    }
    setState((prev) => ({ ...prev, [view]: true }));
    dispatch(clearContractError()) 
  }, [clientIdNumber, clientContract]);

  const handleCloseModal = useCallback(
    (view, refresh) => {
      setState((prev) => ({ ...prev, [view]: false }));
      if (refresh) {
        dispatch(getClientContract(contractId));
      }
    },
    [dispatch, contractId],
  );

  const handleDeactivateModal = useCallback(() => {
    handleCloseModal(viewDocument.isAnnul);
    dispatch(cancelContract({dealId: contractId, unnecessary: 'false'}));
  }, [dispatch, contractId]);

  const handleChangeContract = useCallback(
    (data) => {
      if (data?.cashBoxId) data.cashBoxId = data.cashBoxId.value;
      if (data?.delayPercent) data.delayPercent = +data.delayPercent;
      if (data?.basePercent) data.basePercent = +data.basePercent;

      dispatch(changeClientContract(clientContract.dealId, data, clientId));
    },
    [clientContract.dealId, dispatch],
  );

  const handleAddRedemptionDate = useCallback(
    (data) => {
      const retentionData = {
        id: clientContract?.dealId,
        date: data?.redemptionDate,
      };
      if (clientContract.redemptionDate)
        dispatch(getDealToRetentionFailed('Обещанную дату выкупа можно применить только один раз'));
      if (!clientContract.redemptionDate && data.redemptionDate)
        dispatch(getDealToRetention(retentionData));
    },
    [dispatch, clientContract],
  );

  const changeIsShow = useCallback(
    (view) => {
      setState((prev) => ({
        ...prev,
        isShow: {
          ...state.isShow,
          [view]: !state.isShow[view],
        },
      }));
    },
    [state.isShow],
  );

  const addToTransfer = useCallback(() => {
    handleCloseModal(viewDocument.isToTransfer);
    dispatch(changeContractStatuses([contractId], contractStatuses.TOTRANSFER.param));
  }, [handleCloseModal, dispatch, contractId]);
 
  const sendWithdrawalKB = useCallback(() => {
    handleCloseModal(viewDocument.isKBWithdrawal);

    const code = getCodeFromDeals([clientContract])
    const operation = operations.find(operation => operation.type === WITHDRAWAL_OPERATION)
    dispatch(createMessage({ dealId: contractId, type: 'WITHDRAWAL', operationId: operation.id, codes: [creditDealTypeCode.MFO_LOAN_AGREEMENT, code] }));
  }, [handleCloseModal, dispatch, contractId, clientContract, operations]);

  const printExtensionSupplementalAgreement = () => {
    const filename = `exp_.pdf`;
    const reaBody = {
      dealId: clientContract.dealId,
      cashBoxId: clientContract.cashBoxId
    }
    dispatch(getPrintedForm(reaBody, filename, viewReports.SUPPLEMENTARY_AGREEMENT))
  }

  const supplementaryAgreement = () => {
    const filename = `exp_.pdf`;
    const reaBody = {
      dealId: clientContract.dealId,
      cashBoxId: clientContract.cashBoxId
    }
    dispatch(getPrintedForm(reaBody, filename, viewReports.ADDITIONAL_AGREEMENT))
  }

  const returnFieldsPosition = () => {
    return (
      notEmpty &&
      clientContract.positions.map((position) => {
        const type = {
          PURITY: {
            comment: position.comment,
            grossWeight: position.grossWeight,
            names: position.names.map((i, ind) => ({ label: i, value: ind })),
            pureWeight: position.pureWeight,
            quantity: position.quantity,
            positionId: position.positionId,
            purityId: position.purityId,
          },
          THINGS: {
            imei: position.imei,
            model: position.model,
            names: position.names[0],
            quantity: position.quantity,
            serialNumber: position.serialNumber,
            positionId: position.positionId,
            additionalInfo: position.additionalInfo,
          },
          CARS: {
              positionId: position.positionId,
              names:[ {label: position.names[0], value: position.names[0] }],
              model: {label: position.model, value: position.model },
              carDate: position.carDate,
              registrationNumber: position.registrationNumber,
              quantity: position.quantity,
              marketPrice: position.marketPrice,
              estimatedValue: position.estimatedValue,
              certificateNumber: position.certificateNumber,
              certificateDate: position.certificateDate,
              vin: position.vin,
              stateOFTheVehicle: position.stateOFTheVehicle,
              storageInCashBox: position.storageInCashBox,
              comment: '',
          }
        }
        return type[clientContract.type]
      })
    );
  };

  const updateData = () => {
    dispatch(getClientContract(clientContract.dealId));
  }

  const isClientInactive = () => {
    validateClientStatus()
  };

  const selectTab = (ind) => {
    localStorage.setItem(CLIENTCONTRACT_OPERATIONS_TAB, ind);
    setTabIndex(ind);
  };

  const openBuyThirdPersonModal = (value) => {
    setState((prev) => ({
      ...prev,
      isBuyThirdPerson: {
        isOpen: value,
        data: null,
      },
    }));
  };

  const closeBuyThirdPersonModal = () => {
    setState((prev) => ({
      ...prev,
      isBuyThirdPerson: {
        data: null,
        isOpen: false,
      },
    }));
  };

  const onSubmitBuyThirdPerson = (data) => {
    setState((prev) => ({
      ...prev,
      isBuyThirdPerson: {
        isOpen: false,
        data,
      },
    }));
  };
  const filterNames = (arr) => {
    const filterArr = arr.filter(n => n !== 'ч.' && n !== 'б/вст' && n !== 'с/вст' && n !== '/вставка')
    if (filterArr?.length > 1) {
      return {value: 0, label: filterArr.join(',')}
    }
    return {value: 0, label: filterArr[0]}
  }

  const copyDeal = () => {
    const type = clientContract.type;
    const typeTab = {
      PURITY: 0,
      THINGS: 1,
      CARS: 2,
    }

    const data = {
      calculation: {
        amount: clientContract.amount,
        endDate: moment().format('YYYY-MM-DD'),
        waiverOfRedemption: false,
        months: optionsPaymentAnnuityDate.find(date => date.value === Number(clientContract.months)),
        firstPaymentDate: clientContract.firstPaymentDate,
      },
      dealForm: clientContract.form,
      calculationTab: 0,
      typeTab: typeTab[type],
      coupon: {label: clientContract.couponName, value: clientContract.couponId },
      cashbox: {label: clientContract.cashBoxName, value: clientContract.cashBoxId},
    };


    if (type === 'PURITY') {
      data.purities = clientContract.positions.map((i) => ({
        grossWeight: i.grossWeight,
        pureWeight: i.pureWeight,
        quantity: i.quantity,
        jewel: filterNames(i.names),
        purity: { value: i.purityId, label: `${i.purityType} ${i.purityName}` },
        puritiesComment: i.comment,
        showComment: i.comment,
        isPart: i.names.includes('ч.'),
        additionalInfo: i.additionalInfo,
      }));
    }

    if (type === 'THINGS') {
      const { imei, model, names, quantity, serialNumber, additionalInfo } = clientContract.positions[0]
      data.things = {
        comment: '',
        estimatedValue: '',
        imei: imei,
        model: model,
        name: names[0],
        quantity: quantity,
        sn: serialNumber,
        additionalInfo: additionalInfo,
      };
    }

    if (type === 'CARS') {
      const {
        names,
        model,
        carDate,
        estimatedValue,
        vin,
        registrationNumber,
        certificateNumber,
        certificateDate,
        marketPrice,
        stateOFTheVehicle,
        additionalInformation
      } = clientContract.positions[0];

      data.cars = {
        comment: '',
        makeOfCar: { label : names[0], value: 1 },
        model: { label : model, value: model },
        year: { label : carDate, value: carDate },
        estimatedPrice: estimatedValue,
        VIN: vin,
        carNumber: registrationNumber,
        registrationNumber: certificateNumber,
        registrationDate: certificateDate,
        marketPrice: marketPrice,
        garage: 'Без хранения в ломбарде',
        condition: stateOFTheVehicle,
        additionalInfo: additionalInformation,
      };
    }

    if (goodSpecialistRole && clientContract.cashBoxName !== dataActiveCashbox.label) {
      data.cashbox = {label: dataActiveCashbox.label, value: dataActiveCashbox.value}
      data.coupon = {label: '', value: ''}
    }
    if (permissionsAccess("action.cashbox.details")) {
      dispatch(getCashbox({id: clientContract.cashBoxId, type: dealTypes[data.dealForm].couponType}))
    }

    localStorage.setItem(QUICK_CALCULATION_DATA, JSON.stringify(data));
    history.push({ pathname: `/client/${clientId}/contract` });
    dispatch(saveCalculations());
  };

  const openAdditionalAgreementPercent = useCallback(() => {
    const filename =
      'exp_' +
      clientContract.dealNumber +
      '_' +
      clientContract.startDate +
      '_' +
      clientContract.endDate +
      '.pdf';

    dispatch(
      getPrintedForm(
        {
          dealId: clientContract.dealId,
          cashBoxId: dataActiveCashbox.value,
        },
        filename,
        viewReports.SUPPLEMENTARY_AGREEMENT_PERCENT,
      ),
    );
  }, [clientContract, dispatch, dataActiveCashbox.value]);

  const chooseMoneyOperation = (e) => {
    const payload = {
      clientContractCashBoxId: clientContract.cashBoxId,
      activeCashBoxId: mainAccessPartialQuenchingModal ? clientContract.cashBoxId : activeCashBoxId,
      operationWithMoney: e.label
    }
    dispatch(resetCalculations());
    if (clientContract.cashBoxId) {
      dispatch(getPartialQuenchingData(payload))
    }
  };

  const isOldContract = ()=>{
    if (notEmpty) {
      const purities = clientContract?.positions.map((i) => (
        i.names
          .filter(n => n !== 'ч.' && n !== 'б/вст' && n !== 'с/вст' && n !== '/вставка').length
      ))
      for (let i = 0; i < purities.length; i++) {
        if (purities[i] > 1) {
          return true;
        }
      }
      return false;
    }
  }

  const closeAlertModal = useCallback(() => {
    setPopup((prev) => ({...prev, isOpen: false}));
  }, []);

  return (
    <div className="content-inner-data-container clientContract-container">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {(fileError || contractError) && <Message type="error" text={fileError || contractError} />}
          <fieldset>
            <div className="content-section-title">
              <div className="content-section-title-actionitems">
                <div className="content-section-title-actionitems-left">
                  <div className="content-section-title-actionitems-left-top">
                    {(isShowButton ||
                      clientContract?.status === contractStatuses.TOTRANSFER.param) &&
                      permissionsAccess("deal.update.deal_number")
                    ? (
                      <ClientDropdown
                        text="Изменить номер договора"
                        handleChangeContract={handleChangeContract}
                        content={viewDropdown.dealNumber}
                        initValues={{ dealNumber: clientContract.dealNumber }}
                        isShow={state.isShow}
                        changeIsShow={changeIsShow}
                        viewDropdown={viewDropdown}>
                        <span>
                          <strong>
                            <big>
                              Договор №
                              {(clientContract?.dealNumber && clientContract.dealNumber) ||
                                (clientContract?.dealId && clientContract.dealId)}
                            </big>
                          </strong>
                        </span>
                      </ClientDropdown>
                    ) : (
                      <h2>
                        <span>
                          <strong>
                            <big>
                              Договор №
                              <span className={clientContract?.status === contractStatuses.UNNECESSARY.param ? 'reverted' : ''}>
                                {(clientContract?.dealNumber && clientContract.dealNumber) ||
                                (clientContract?.dealId && clientContract.dealId)}
                              </span>
                            </big>
                          </strong>
                        </span>
                      </h2>
                    )}
                    <div className="content-section-title-actionitems-info clientContract-actionitems-info">
                      <IconStatus status={clientContract?.status && clientContract.status} />
                      <p>
                        <span className="icon">
                          <CalendarIcon />
                        </span>
                        {clientContract?.startDate &&
                          moment(clientContract.startDate).format('DD.MM.YYYY')}{' '}
                        —{' '}
                        {clientContract?.endDate &&
                          moment(clientContract.endDate).format('DD.MM.YYYY')}
                      </p>
                    </div>
                  </div>
                  <div className="clientContract-contract-info">
                    <div className="clientContract-contract-info-status">
                      <p>{clientContract?.couponName && clientContract.couponName}</p>
                      {isShowButton && permissionsAccess("deal.update.base_percent") ? (
                        <ClientDropdown
                          text="Изменить процент по договору"
                          handleChangeContract={handleChangeContract}
                          content={viewDropdown.basePercent}
                          initValues={{ basePercent: clientContract.basePercent }}
                          isShow={state.isShow}
                          changeIsShow={changeIsShow}
                          viewDropdown={viewDropdown}>
                          <span>{clientContract.basePercent} %</span>
                        </ClientDropdown>
                      ) : (
                        <p>{clientContract.basePercent} % в день</p>
                      )}
                    </div>
                    <div className="clientContract-contract-info-data">
                      <div className="clientContract-contract-info-data-parameters">
                        {clientContract?.payableForToday ? (
                          <p>
                            К выплате на сегодня:{' '}
                            {clientContract?.payableForToday && clientContract.payableForToday} руб.
                          </p>
                        ) : null}
                      </div>
                      <div className="clientContract-contract-info-data-parameters">
                        <div className="form-row">
                          <div className="form-row-item clientContract-contract-row-item">
                            <div className="form-element">
                              <label className="form-element-label" htmlFor="#">
                                Неустойка
                              </label>
                              <div className="form-element-data">
                                <div className="form-element-data-text">
                                  {isShowButton && permissionsAccess("deal.update.delay_percent") ? (
                                    <ClientDropdown
                                      text="Изменить процент неустойки"
                                      handleChangeContract={handleChangeContract}
                                      content={viewDropdown.delayPercent}
                                      initValues={{ delayPercent: clientContract.delayPercent }}
                                      isShow={state.isShow}
                                      changeIsShow={changeIsShow}
                                      viewDropdown={viewDropdown}>
                                      <span>
                                        {clientContract?.delayPercent &&
                                          clientContract.delayPercent}{' '}
                                        %
                                      </span>
                                    </ClientDropdown>
                                  ) : (
                                    <p>
                                      {clientContract?.delayPercent && clientContract.delayPercent}{' '}
                                      %
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="form-row-item clientContract-contract-row-item">
                            <div className="form-element">
                              <label className="form-element-label" htmlFor="#">
                                Находится в
                              </label>
                              <div className="form-element-data">
                                <div className="form-element-data-text">
                                  {isShowButton && accessFeatures["deal.edit.cash_box"] && permissionsAccess("deal.update.cashbox_name") ? (
                                    <ClientDropdown
                                      text="Изменить подразделение"
                                      handleChangeContract={handleChangeContract}
                                      content={viewDropdown.cashBox}
                                      initValues={{
                                        cashBoxId: {
                                          value: clientContract.cashBoxId,
                                          label: clientContract.cashBoxName,
                                        },
                                      }}
                                      isShow={state.isShow}
                                      changeIsShow={changeIsShow}
                                      viewDropdown={viewDropdown}>
                                      <span>
                                        {clientContract?.cashBoxName && clientContract.cashBoxName}
                                      </span>
                                    </ClientDropdown>
                                  ) : (
                                    <p>
                                      {clientContract?.cashBoxName && clientContract.cashBoxName}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="content-section-title-actionitems-right">
                  <div className="action-items">
                  {(clientContract.status === contractStatuses.EXPIRED_PAYMENT.param
                  || clientContract.status === contractStatuses.ACTIVE.param
                  || clientContract.status === contractStatuses.EXPIRED.param) && typeAnnuity ? (
                    <>
                      {permissionsAccess("action.deal.closure") && (
                        <ActionButton
                          text="Закрыть"
                          func={openModal}
                          param={typeAnnuity ? viewDocument.isCloseAnnuityDeal : viewDocument.isClosed}
                          disabled={disableClose(clientContract)}
                          styleName={clientIdNumber ? 'disabled-action-item' : 'action-item'}
                        />
                      )}
                          <ActionButton
                              text="Аннуитетные платежи"
                              func={() => openModal(viewDocument.isPayAnnuity)}
                          />
                      {permissionsAccess("action.deal.edit") &&
                          <ActionButton
                              text="Редактировать"
                              func={openModal}
                              param={viewDocument.isEdit}
                          />
                      }
                      {permissionsAccess("action.deal.status.cancellation") && clientContract.status !== contractStatuses.UNNECESSARY.param && (
                          <ActionButton
                              text="Аннулировать"
                              func={openModal}
                              param={viewDocument.isAnnul}
                              disabled={disableCancel(clientContract)}
                        />
                      )}
                      {permissionsAccess("action.deal.status.transfer") && (
                          <ActionButton
                              text={clientContract.type === 'CARS' ? "В гараж" : "На передачу"}
                              func={openModal}
                              param={viewDocument.isToTransfer}
                          />
                      )}
                      {permissionsAccess("action.report.generate") && clientContract.status !== contractStatuses.UNNECESSARY.param && (
                        <ActionButton
                          text="Открыть договор"
                          func={openPrintendForm}
                        />
                      )}
                      <ActionButton
                          text="Доп. Cоглашение"
                          func={supplementaryAgreement}
                      />
                    </>
                  ) : (
                    <>
                      {isValidStatus && permissionsAccess("action.deal.closure") && (
                        <ActionButton
                          text="Закрыть"
                          func={openModal}
                          param={typeAnnuity ? viewDocument.isCloseAnnuityDeal : viewDocument.isClosed}
                          disabled={disableClose(clientContract)}
                          styleName={clientIdNumber ? 'disabled-action-item' : 'action-item'}
                        />
                      )}

                      {canExtendDeal && !typeAnnuity && (
                        <ActionButton
                          text="Продлить"
                          func={openModal}
                          param={viewDocument.isProlong}
                          disabled={disableProlong(clientContract)}
                          styleName={isDisabledProlong ? 'disabled-action-item' : 'action-item'}
                        />
                      )}

                      {!typeAnnuity && isActiveStatus && type && (accessPartialQuenchingModal || mainAccessPartialQuenchingModal) && accessFeatures['deals.partial_payment'] && (
                        <div className="client-contract">
                          {(inactiveClient || clientIdNumber) && <div className="hiding-div disabled-action-item" onClick={isClientInactive}></div>}

                          <Select
                            classNamePrefix="select"
                            className="clientContract-contract-select"
                            placeholder="Изменение суммы"
                            options={moneyOperation}
                            onChange={chooseMoneyOperation}
                          />
                        </div>
                      )}

                      {permissionsAccess("action.deal.status.cancellation") && clientContract.status !== contractStatuses.UNNECESSARY.param && (
                        <ActionButton
                          text="Аннулировать"
                          func={openModal}
                          param={viewDocument.isAnnul}
                          disabled={disableCancel(clientContract)}
                        />
                      )}

                      {permissionsAccess("action.deal.redemption.date") && clientContract.status === contractStatuses.EXPIRED.param && (
                        <ClientDropdown
                          text="Обещанная дата выкупа"
                          handleChangeContract={handleAddRedemptionDate}
                          content={viewDropdown.redemptionDate}
                          initValues={{ redemptionDate: clientContract.redemptionDate }}
                          isShow={state.isShow}
                          changeIsShow={changeIsShow}
                          viewDropdown={viewDropdown}
                        >
                          <span className="action-dropdown">Обещанная дата выкупа</span>
                        </ClientDropdown>
                      )}

                      {clientContract.status !== contractStatuses.UNNECESSARY.param && permissionsAccess("action.report.generate") && (
                        <>
                          <ActionButton text="Открыть договор" func={openPrintendForm} />
                          {
                              !typeAnnuity && <ActionButton text="Доп соглашение %" func={openAdditionalAgreementPercent} />
                          }
                        </>
                      )}

                      {!isShowButton && permissionsAccess("deal.create.copy") && showCopyButtonByStatus && (
                        <ActionButton
                          text="Копировать"
                          func={copyDeal}
                          disabled={isOldContract() && !permissionsAccess('deal.copy.old_contract')}
                        />
                      )}

                      {permissionsAccess("action.deal.status.transfer") && isShowButton && (
                        <ActionButton
                          text={clientContract.type === 'CARS' ? "В гараж" : "На передачу"}
                          func={openModal}
                          param={viewDocument.isToTransfer}
                        />
                      )}

                      {(isShowButton ||
                        clientContract.status === contractStatuses.TOTRANSFER.param ||
                        clientContract.status === contractStatuses.GOHRAN.param ||
                        clientContract.status === contractStatuses.STORE.param) && permissionsAccess("action.deal.edit") && (
                          <ActionButton
                            text="Редактировать"
                            func={openModal}
                            param={viewDocument.isEdit}
                          />
                      )}

                      {clientContract.status === contractStatuses.WITHDRAWAL.param && permissionsAccess("action.integration.kb.event") && (
                        <ActionButton
                          text="Передача данных КБ"
                          func={openModal}
                          param={viewDocument.isKBWithdrawal}
                        />
                      )}

                      {!typeAnnuity && permissionsAccess("action.report.generate") && (
                        <ActionButton
                          text="Доп.соглашение продления"
                          func={printExtensionSupplementalAgreement}
                        />
                      )}
                    </>
                  )}
                  </div>
                </div>
              </div>
            </div>
            <div className="content-section-title m-b-0">
              <div className="content-section-title-actionitems">
                <h2>Залоговая ценность</h2>
              </div>
            </div>
          </fieldset>
          <div className="content-datatable">
            <div className="content-datatable-content">
              <TableLayout tableView={clientContract.type} clientContract={clientContract} />
            </div>
          </div>
          <Tabs defaultIndex={tabIndex} onSelect={selectTab} className="m-t-spacer-4">
            <TabList className="content-tabs offset">
              <Tab className="button-tab" selectedClassName="active">
                Операции
              </Tab>
              <Tab className="button-tab" selectedClassName="active">
                История
              </Tab>
              {accessKB && (
                <Tab className="button-tab" selectedClassName="active">
                  КБ
                </Tab>
              )}
            </TabList>
            <TabPanel>
              <ContractTransactions dealId={contractId} />
            </TabPanel>
            <TabPanel>
              <LayoutOperations
                contractId={contractId}
                clientContract={clientContract}
                type={clientContract.type}
              />
            </TabPanel>
            {accessKB && (
              <TabPanel>
                <KBMessages dealId={contractId} />
              </TabPanel>
            )}
          </Tabs>
          <ProlongModal
            isOpen={state.isProlong}
            paramReq={dataRef.current?.paramReq}
            handleCloseModal={handleCloseModal}
            paramReqList={state}
            clientId={dataRef.current?.clientId}
            cashBoxId={dataActiveCashbox.value}
            page={true}
            status={clientContract.status}
          />
          <CloseDealModal
            isOpen={state.isClosed}
            deals={dataRef.current?.paramReq}
            handleCloseModal={(isClosed) => handleCloseModal(viewDocument.isClosed, isClosed)}
            openBuyThirdPersonModal={openBuyThirdPersonModal}
            isBuyThirdPerson={state.isBuyThirdPerson}
            cashBoxId={dataActiveCashbox.value}
          />
          <ConfirmModal
            isOpen={state.isAnnul}
            handleClose={() => handleCloseModal(viewDocument.isAnnul)}
            handleAction={handleDeactivateModal}
            headerText="Аннулирование залогового билета"
            bodyText="Вы действительно хотите аннулировать залоговый билет?"
          />
          <AlertModal
            isOpen={popup.isOpen}
            handleClose={closeAlertModal}
            header={popup.header}
            text={popup.text}
          />
          {
            state.isEdit &&
            <EditDealModal
              isOpen={state.isEdit}
              clientContract={clientContract}
              handleCloseModal={handleCloseModal}
              type={clientContract.type}
              initValues={{ positions: returnFieldsPosition() }}
            />
          }
          <ConfirmModal
            isOpen={state.isToTransfer}
            handleClose={() => handleCloseModal(viewDocument.isToTransfer)}
            handleAction={addToTransfer}
            headerText={ clientContract.type === 'CARS' ? "Вы хотите переместить в гараж?" :"Вы хотите переместить на передачу?"}
          />
          <ConfirmModal
            isOpen={state.isKBWithdrawal}
            handleClose={() => handleCloseModal(viewDocument.isKBWithdrawal)}
            handleAction={sendWithdrawalKB}
            headerText="Вы хотите отправить изъятие в КБ?"
          />
          <BuyThirdPersonModal
            isOpen={state.isBuyThirdPerson.isOpen}
            onSubmitBuyThirdPerson={onSubmitBuyThirdPerson}
            closeBuyThirdPersonModal={closeBuyThirdPersonModal}
          />
          {
            state.isPayAnnuity && <PayAnnuityPeriod
                  isOpen={state.isPayAnnuity}
                  onClose={() => handleCloseModal(viewDocument.isPayAnnuity)}
                  dealId={clientContract.dealId}
                  dealNumber={clientContract.dealNumber}
                  item={[clientContract]}
                  updateData={updateData}
              />
          }
          {
            state.isCloseAnnuityDeal && <CloseAnnuityDeal
                  isOpen={state.isCloseAnnuityDeal}
                  onClose={() => handleCloseModal(viewDocument.isCloseAnnuityDeal)}
                  dealId={[clientContract.dealId]}
                  isBuyThirdPerson={state.isBuyThirdPerson}
                  openBuyThirdPersonModal={openBuyThirdPersonModal}
                  items={[clientContract]}
                  updateData={updateData}
              />
          }
          {state.isPartialQuenching &&
              <PartialQuenchingModal
                  isOpen={state.isPartialQuenching}
                  clientContract={clientContract}
                  handleCloseModal={handleCloseModal}
                  type={type}
                  initValues={{ positions: returnFieldsPosition() }}
              />
          }

        </>
      )}
      <BasicAlert onClose={() => setAlertMessage(null)}
          message={alertMessage}
          isOpen={!!alertMessage}
          isError={true}
        />
    </div>
  );
});

function disableCancel(deal) {
  const createdToday = moment().isSame(deal?.startDate, 'day');
  return isDeactivated(deal) || !createdToday;
}

function disableClose(deal) {
  return isDeactivated(deal);
}

function disableProlong(deal) {
  return isDeactivated(deal);
}

function isDeactivated(deal) {
  if (!deal?.status) {
    return true;
  }
  const statuses = [contractStatuses.CANCELED.param, contractStatuses.CLOSED.param];
  return statuses.includes(deal.status);
}

export default ClientContract;
